import { combineReducers } from 'redux';
import CommercialAgents from './CommercialAgents/reducer';
import Projects from './Projects/reducer';
import ProjectsGit from './ProjectsGit/reducer';
import Issues from './Issues/reducer';

export default combineReducers({
    Issues,
    ProjectsGit,
    CommercialAgents,
    Projects
});



// WEBPACK FOOTER //
// ./environments/simulationenr/data/reducer.js